// extracted by mini-css-extract-plugin
module.exports = {"tableTitleCell":"PositionInformation_tableTitleCell__3FMHH","dataClassCell":"PositionInformation_dataClassCell__Y1RRk"};